<div class="relative flex flex-wrap items-center gap-3">
  <article class="flex h-10 rounded">
    <app-input-search
      [placeholder]="literalService.get('vehicles.search', true)"
      (submitEventEmitter)="searchEventEmitter.emit($event)"
    ></app-input-search>
  </article>
  <button
    class="filter-button relative inline-flex h-10 items-center rounded px-4 py-2 font-bold text-neutrals-grey-06"
    [ngClass]="{'filter-open': filterOpened() || filtersApplied() > 0}"
    (click)="toggleFilter()"
  >
    <img [src]="images.filter" alt="filter" class="mr-2 h-5 w-5" [ngClass]="filterOpened() ? 'filter-primary-purple-light' : ''" />
    <span class="text-base font-semibold" [ngClass]="{'text-primary-purple-light': filterOpened()}">{{ literalService.get('vehicles.filter', true) }}</span>
    @if (filtersApplied() > 0) {
      <span class="filter-bubble absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full text-xs font-bold">
        {{ filtersApplied() }}
      </span>
    }
  </button>
  <article class="absolute left-0 top-full z-40 mt-3 w-max max-w-[90vw]" [class.hidden]="!filterOpened()">
    <app-filter-panel
      [fields]="filterFields"
      [filterType]="filterTypes.VEHICLES"
      [selection]="filterSelection()"
      (filter)="onFilter($event)"
      (closeFilter)="filterOpened.set(false)"
    />
  </article>
  <app-custom-toggle
    [id]="'vehicles-group-by-toggle'"
    [selectedValue]="groupBy()"
    [options]="groupByToggleOptions"
    (action)="onGroupByToggle()"
  />
  <details class="dropdown" #viewModeDropdown (toggle)="onDropdownToggle(viewModeOpened, viewModeDropdown)">
    <summary
      class="list-none flex h-7 w-20 cursor-pointer items-center justify-between rounded border bg-neutrals-grey-01 px-2 font-semibold text-neutrals-grey-06"
    >
      {{ literalService.get(viewModeLabels[viewMode()], true) }}
      <img [src]="images.arrowDown" alt="viewMode" class="h-4 w-4 transition-transform" [ngClass]="{ 'rotate-180': viewModeOpened() }" />
    </summary>
    <ul tabindex="0" class="dropdown-content menu z-50 w-32 rounded-b shadow bg-neutrals-white p-0 overflow-hidden">
      @for (mode of viewModes; track mode) {
        <li>
          <button
            type="button"
            class="font-normal! rounded-none! hover:bg-primary-purple-light hover:text-neutrals-white"
            [ngClass]="mode === viewMode() ? 'text-primary-purple bg-neutrals-grey-02' : 'text-neutrals-grey-06'"
            (click)="onViewModeChange(mode)"
          >
            {{ literalService.get(viewModeLabels[mode], true) }}
          </button>
        </li>
      }
    </ul>
  </details>
  <button id="now-button" class="btn btn-sm border-gray-200 font-semibold rounded-lg bg-neutrals-grey-01 h-7" (click)="goToNowEventEmitter.emit()">
    {{ literalService.get('vehicles.now', true) }}
  </button>
  <div class="flex items-center gap-2">
    <img [src]="images.zoomOut" alt="zoomOut" class="h-4 w-4 cursor-pointer" (click)="onZoomChange(zoom() - 0.1)"/>
    <input
      type="range"
      class="range range-xs w-32"
      min="0"
      max="1"
      step="0.01"
      [value]="zoom()"
      (input)="onZoomChange($event)"
    />
    <img [src]="images.zoomIn" alt="zoomIn" class="h-4 w-4 cursor-pointer" (click)="onZoomChange(zoom() + 0.1)"/>
    <span class="w-8 text-xs font-semibold text-neutrals-grey-04">{{ zoomLabel() }}</span>
  </div>
  <section class="ml-auto flex items-center gap-4">
    <details class="dropdown dropdown-end" #viewOptionsDropdown (toggle)="onDropdownToggle(viewOptionsOpened, viewOptionsDropdown)">
      <summary
        class="list-none outlinedButton flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border shadow!"
        [ngClass]="viewOptionsOpened() ? 'border-primary-purple-light! bg-primary-purple-light-2' : 'border-gray-300'"
      >
        <img [src]="images.visibility" alt="viewOptions" class="h-6 w-6" [ngClass]="{ 'filter-primary-purple-light': viewOptionsOpened() }" />
      </summary>
      <div tabindex="0" class="dropdown-content z-50 mt-2 flex w-max flex-col gap-4 rounded-md bg-primary-purple-light-2 p-4 shadow">
        <div class="flex items-center justify-between gap-8">
          <h2 class="text-lg font-bold text-primary-purple">{{ literalService.get('vehicles.actions.viewOptions.title', true) }}:</h2>
        </div>
        @for (option of viewOptionKeys; track option) {
          <app-checkbox
            [id]="`schedule-view-option-${option}`"
            [text]="literalService.get(`vehicles.actions.viewOptions.${option}`, true)"
            [checked]="viewOptions()[option]"
            (onChange)="onViewOptionChange(option, $event)"
          />
        }
      </div>
    </details>
    <a class="outlinedButton inline-flex cursor-pointer items-center justify-center gap-2 rounded-[30px] px-4 py-1.5 h-10" (click)="onNewVehicle()">
      <img [src]="images.busCar" alt="newVehicle" class="h-6 w-6" />
      <span class="text-primary-purple text-base font-semibold">{{ literalService.get('vehicles.newVehicle', true) }}</span>
    </a>
  </section>
</div>
